import React from 'react';
import H2HeaderText from '../../ui/typography/H2HeaderText';
import H3HeaderText from '../../ui/typography/H3HeaderText';
import BaseText from '../../ui/typography/BaseText';
import { StaticImage } from 'gatsby-plugin-image';
import { FONT_SIZE } from '../../../constants/enum';
import InputSM from '../../ui/Input/InputSM';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import hsbcBank from '../../../images/homePageImages/hsbcBankLogo.png';
import PrimaryButton from '../../ui/buttons/PrimaryButton';
import { navigate } from 'gatsby';
import { PAGES_ENDPOINTS } from '../../../constants/pages-endpoints';
export default function BusinessRegistrationProces() {
  const schema = yup.object({
    companyName: yup.string().required('Company Name'),
    email: yup.string().email().required('Email')
  });
  const {
    register,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });
  const onSubmit = (data) => {
    navigate(PAGES_ENDPOINTS?.GET_STARTED, { state: { email: data.email, companyName: data?.companyName } });
  };
  return (
    <div className="bg-yellow-200">
      <div className="global-max-width-wrapper mx-auto mt-36">
        <div
          className="bg-white p-12 shadow-lg relative z-10 -mb-44 rounded-md"
          style={{ boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)', top: '-95px' }}
        >
          <section className="flex flex-wrap justify-center">
            <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
              <div className="text-center">
                <H3HeaderText
                  className="text-4xl"
                  textAlign="text-center"
                  fontWeight="text-bold"
                  textColor="text-orange-500"
                  title="1,000+"
                />
                <BaseText textAlign="text-center" textColor="text-gray-500" title="Companies registered in Hong Kong" />
              </div>
            </div>
            <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
              <div className="text-center">
                <H3HeaderText
                  className="text-4xl"
                  fontWeight="text-bold"
                  textColor="text-orange-500"
                  textAlign="text-center"
                  title="800+"
                />
                <BaseText textAlign="text-center" textColor="text-gray-500" title={'Bank Accounts Opened'} />
              </div>
            </div>
            <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
              <div className="text-center">
                <H3HeaderText
                  className="text-4xl"
                  textColor="text-orange-500"
                  fontWeight="text-bold"
                  textAlign="text-center"
                  title="50+"
                />
                <BaseText textAlign="text-center" textColor="text-gray-500" title="Industries Covered" />
              </div>
            </div>
            <div className="w-full sm:w-1/2 lg:w-1/4 mb-8">
              <div className="text-center">
                <H3HeaderText
                  className="text-4xl"
                  textColor="text-orange-500"
                  fontWeight="text-bold"
                  textAlign="text-center"
                  title="25+"
                />
                <BaseText textAlign="text-center" textColor="text-gray-500" title="Nationalities" />
              </div>
            </div>
          </section>
        </div>
        <H2HeaderText
          title={`How does the business \nregistration process work?`}
          className="md:whitespace-pre-line py-32"
          fontWeight="text-regular"
          textAlign="text-center"
        />
        <div className="flex flex-col md:flex-row flex-col-reverse items-end gap-20">
          <StaticImage
            src="../../../images/homePageImages/homeRegistration.png"
            alt="businessRegistration"
            loading="lazy"
          />
          <div className="flex gap-16 flex-col md:w-4/6 mx-auto relative">
            <div className="flex gap-12 items-center timeline-element">
              <div
                style={{ minWidth: '90px', minHeight: '90px' }}
                className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
              >
                1
              </div>
              <div>
                <BaseText fontWeight="text-medium" title="Select a plan" />
                <BaseText
                  className="mt-4"
                  fontWeight="text-medium"
                  textColor="text-gray-350"
                  title={
                    <span>
                      {/* <span className="text-orange-500 text-bold">Choose a plan</span> that suits you best */}
                      <span className="text-orange-500 text-bold pr-1 hover:text-black hover:underline">
                        <a href="#plan-section">Choose a plan</a>
                      </span>
                      that suits you best
                    </span>
                  }
                />
              </div>
            </div>
            <div className="flex gap-12 items-center">
              <div
                style={{ minWidth: '90px', minHeight: '90px' }}
                className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
              >
                2
              </div>
              <div>
                <BaseText fontWeight="text-medium" title="Apply for Your Company Registration" />
                <BaseText
                  className="mt-4"
                  fontWeight="text-medium"
                  textColor="text-gray-350"
                  title="Fill in our electronic form and submit it with a few simple questions about your new business. It only takes 5 minutes."
                />
              </div>
            </div>
            <div className="flex gap-12 items-center">
              <div
                style={{ minWidth: '90px', minHeight: '90px' }}
                className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
              >
                3
              </div>
              <div>
                <BaseText
                  fontWeight="text-bold"
                  textColor="text-orange-500"
                  title="Your new Hong Kong company is incorporated!"
                />
                <BaseText
                  className="mt-4"
                  fontWeight="text-medium"
                  textColor="text-gray-350"
                  title="We take care of all administrative formalities with the Hong Kong companies registry. Incorporating your new company with Air Corporate guarantees successful registration!"
                />
              </div>
            </div>
            <div className="flex gap-12 items-center">
              <div
                style={{ minWidth: '90px', minHeight: '90px' }}
                className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
              >
                4
              </div>
              <div>
                <BaseText fontWeight="text-medium" title="Open a business account" />
                <BaseText
                  fontWeight="text-medium"
                  textColor="text-gray-350"
                  className="whitespace-pre-line mt-4"
                  title={`You’ve incorporated your company digitally, next step is to start banking digitally too!\n\nWe help you apply for an account for the best business accounts, remotely and within 48 hours.`}
                />
                <div className="flex gap-8 my-8 items-center flex-wrap" id="logo-section">
                  <StaticImage src="../../../images/homePageImages/airWallexLogo.png" alt="air-wallex" loading="lazy" />
                  <StaticImage src="../../../images/homePageImages/statrysLogo.png" alt="statrys" loading="lazy" />
                  <StaticImage src="../../../images/homePageImages/logoCurrenxie.png" alt="currenxie" loading="lazy" />
                </div>
                <BaseText title="Or set up a meeting with HSBC or OCBC." />
                <div className="flex gap-8 mt-8 mb-20 items-center flex-wrap">
                  <img alt="hsbc-bank" src={hsbcBank} loading="lazy" />
                  <StaticImage src="../../../images/homePageImages/logoOcbcBank.png" alt="ocbc-bank" loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="bg-white p-12 shadow-lg relative z-10 -mb-44 rounded-md"
          style={{ boxShadow: '0 .125rem .25rem rgba(0,0,0,.075)' }}
        >
          <h3 className="text-45ct text-center mt-2 mb-6">Have a company name in mind?</h3>
          <BaseText
            fontSize={FONT_SIZE.PX_14}
            textAlign="text-center"
            fontWeight="text-bold"
            textColor="text-orange-500"
            title="Pre-register it now!"
          />
          <BaseText
            fontSize={FONT_SIZE.PX_18}
            textAlign="text-center"
            textColor="text-gray-300"
            title="Simple, online & free"
          />
          <div className="flex flex-col md:flex-row gap-8 mt-8 w-full items-start">
            <InputSM
              inputProps={{ ...register(`companyName`) }}
              error={errors?.companyName?.message}
              label="Proposed Company Name"
            />
            <InputSM inputProps={{ ...register(`email`) }} error={errors?.email?.message} label="Your email" />
            <PrimaryButton
              onClick={handleSubmit(onSubmit)}
              boxShadow="0 9px 32px 0 rgba(0,0,0,.2)"
              padding="18px"
              fontWeight="text-regular"
              fontSize={FONT_SIZE.PX_18}
              className="w-full mt-9"
              caption="Pre Register Now"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
